import { render, staticRenderFns } from "./return-visit-view.vue?vue&type=template&id=0b4d4709&scoped=true&"
import script from "./return-visit-view.vue?vue&type=script&lang=js&"
export * from "./return-visit-view.vue?vue&type=script&lang=js&"
import style0 from "./return-visit-view.vue?vue&type=style&index=0&id=0b4d4709&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4d4709",
  null
  
)

export default component.exports